<ion-header class="alert-settings-header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button class="icon back"></ion-back-button>
    </ion-buttons>
    <ion-title>
      {{ 'ALERT_SETTINGS.ALERT_SETTINGS' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<h4 class="title">{{ 'ALERT_SETTINGS.ALERT_SETTINGS' | translate }} <ion-icon name="close" (click)="onDismiss ? onDismiss() : goBack()"></ion-icon></h4>

<!-- View mode: read-only current settings -->
<ion-list *ngIf="viewMode" id="alert-settings-popup" class="view-mode-list">
  <div class="kiln-toolbar-row">
    <ion-item class="kiln-select-row" [detail]="kilns && kilns.length > 1" lines="none" button (click)="openKilnSelect()">
      <ion-label>
        <span class="kiln-select-label">{{ 'ALERT_SETTINGS.VIEWING_SETTINGS_FOR' | translate }}</span>
        <span *ngIf="selectedKiln" class="kiln-select-value">{{ selectedKiln.name }}</span>
        <span *ngIf="kilns && kilns.length === 0" class="kiln-select-hint">{{ 'ALERT_SETTINGS.NO_KILNS_FETCHED' | translate }}</span>
        <span *ngIf="kilns && kilns.length > 1" class="kiln-select-hint">{{ 'ALERT_SETTINGS.TAP_TO_CHANGE_KILN' | translate }}</span>
      </ion-label>
      <ion-select #kilnSelectRef *ngIf="kilns && kilns.length > 0" slot="end" [value]="selectedKiln" (ionChange)="onViewKilnChange($event)"
        [compareWith]="compareKilns" [placeholder]="'ALERT_SETTINGS.CHOOSE_A_KILN_PLACEHOLDER' | translate"
        interface="action-sheet" class="kiln-select-control">
        <ion-select-option *ngFor="let k of kilns" [value]="k">{{ k.name }}</ion-select-option>
      </ion-select>
    </ion-item>
    <div class="toolbar-actions-right">
      <ion-button class="edit-btn-in-row toolbar-action-btn" (click)="startEditing()" [disabled]="!kilns || kilns.length === 0" color="primary" size="small"
        [attr.aria-label]="'ALERT_SETTINGS.EDIT' | translate">
        <ion-icon name="create-outline" class="toolbar-btn-icon"></ion-icon>
        <span class="toolbar-btn-text">{{ 'ALERT_SETTINGS.EDIT' | translate }}</span>
      </ion-button>
      <ng-container *ngIf="canAdminister && selectedKiln && !showCopyToPanel">
        <ion-button class="toolbar-action-btn" size="small" fill="outline" color="medium" (click)="clearAllAlerts()" [disabled]="bulkOperationInProgress || loadingView"
          [attr.aria-label]="'ALERT_SETTINGS.CLEAR_ALL_ALERTS' | translate">
          <ion-icon name="trash-outline" class="toolbar-btn-icon"></ion-icon>
          <span class="toolbar-btn-text">{{ 'ALERT_SETTINGS.CLEAR_ALL_ALERTS' | translate }}</span>
        </ion-button>
        <ion-button class="toolbar-action-btn" size="small" fill="outline" color="medium" (click)="openCopyToPanel()" [disabled]="bulkOperationInProgress || loadingView || getOtherKilns().length === 0"
          [attr.aria-label]="'ALERT_SETTINGS.COPY_ALERT_SETTINGS_TO' | translate">
          <ion-icon name="copy-outline" class="toolbar-btn-icon"></ion-icon>
          <span class="toolbar-btn-text">{{ 'ALERT_SETTINGS.COPY_ALERT_SETTINGS_TO' | translate }}</span>
        </ion-button>
      </ng-container>
    </div>
  </div>
  <ng-container *ngIf="showCopyToPanel && canAdminister">
    <ion-item-divider color="light"><ion-label>{{ 'ALERT_SETTINGS.SELECT_KILNS_TO_COPY_TO' | translate }}</ion-label></ion-item-divider>
    <ion-item *ngFor="let k of getOtherKilns()" button (click)="toggleCopyTarget(k)" detail="false">
      <ion-label>{{ k.name }}</ion-label>
      <ion-icon [name]="isCopyTarget(k) ? 'checkbox' : 'square-outline'" slot="end"></ion-icon>
    </ion-item>
    <ion-item lines="none" class="copy-actions">
      <ion-button size="small" fill="outline" color="dark" class="copy-cancel-btn" (click)="cancelCopyTo()">{{ 'ALERT_SETTINGS.CANCEL' | translate }}</ion-button>
      <ion-button size="small" (click)="copySettingsToSelectedKilns()" [disabled]="copyTargetKilnIds.length === 0 || bulkOperationInProgress">
        {{ 'ALERT_SETTINGS.COPY' | translate }}
      </ion-button>
    </ion-item>
  </ng-container>
  <ion-item *ngIf="loadingView" lines="none">
    <ion-spinner name="bubbles"></ion-spinner>
  </ion-item>
  <ng-container *ngIf="!loadingView && selectedKiln && alertSettings && !showCopyToPanel">
    <ion-item-divider color="light">
      <ion-label>{{ 'ALERT_SETTINGS.CURRENT_SETTINGS' | translate }}</ion-label>
    </ion-item-divider>
    <div class="view-settings-scroll">
      <ion-item-group *ngFor="let alert of alerts">
        <ng-container *ngIf="getSettingForType(alert.type) as setting">
          <ion-item detail="false" lines="full" class="current-setting-row">
            <ion-label>
              <div class="setting-row-header">
                <h2>{{ getAlertName(alert.type) }}</h2>
                <ion-button size="small" class="test-alert-btn" (click)="testAlert(selectedKiln?.mac_address, selectedKiln?.serial_number, alert.type); $event.stopPropagation()">
                  {{ 'ALERT_SETTINGS.TEST_ALERT' | translate }}
                </ion-button>
              </div>
              <p class="setting-meta" *ngIf="['heated-to','cooled-to'].includes(alert.type) && setting.temp_variable != null">
                <span>{{ 'ALERT_SETTINGS.TEMPERATURE_VARIABLE' | translate }}: {{ setting.temp_variable }}</span>
              </p>
              <p *ngIf="(getRecipientCounts(setting).emails + getRecipientCounts(setting).phones + (showPushNotifications ? getRecipientCounts(setting).push : 0)) > 0" class="recipients-summary" (click)="toggleRecipientsDetails(alert.type)">
                <span class="recipient-count"><ion-icon name="call-outline"></ion-icon> {{ getRecipientCounts(setting).phones }}</span>
                <span class="recipient-count"><ion-icon name="mail-outline"></ion-icon> {{ getRecipientCounts(setting).emails }}</span>
                <span class="recipient-count" *ngIf="showPushNotifications && getRecipientCounts(setting).push > 0"><ion-icon name="notifications-outline"></ion-icon> {{ getRecipientCounts(setting).push }}</span>
                <span class="details-label">{{ 'ALERT_SETTINGS.SEE_DETAILS' | translate }}</span>
                <ion-icon [name]="expandedRecipientsType === alert.type ? 'chevron-up' : 'chevron-down'" class="details-chevron"></ion-icon>
              </p>
              <div *ngIf="expandedRecipientsType === alert.type && getRecipientsListForDisplay(setting).length" class="recipients-detail">
                <span *ngFor="let r of getRecipientsListForDisplay(setting)" class="recipient-item">{{ r }}</span>
              </div>
            </ion-label>
          </ion-item>
        </ng-container>
      </ion-item-group>
    </div>
  </ng-container>
</ion-list>

<!-- Edit mode: top bar like view mode, then two columns -->
<ion-list *ngIf="!viewMode" id="alert-settings-popup" class="edit-mode-list">
  <form [formGroup]="alertSettingsForm" (ngSubmit)="saveAlertSettings(alertSettingsForm.value)">
    <!-- Top bar full width: Editing settings for [name] | Back to View, Save -->
    <div class="edit-toolbar-row">
      <div class="edit-toolbar-label">
        <span class="editing-kiln-label">{{ 'ALERT_SETTINGS.EDITING_SETTINGS_FOR' | translate }}</span>
        <strong class="editing-kiln-name">{{ selectedKiln?.name }}</strong>
      </div>
      <div class="edit-toolbar-actions">
        <ion-button fill="outline" size="small" color="dark" (click)="cancelEditing()">{{ 'ALERT_SETTINGS.BACK_TO_VIEW' | translate }}</ion-button>
      </div>
    </div>

    <div class="edit-mode-columns">
      <!-- Left: Select alert types (multiple) -->
      <div class="edit-column edit-column-alerts">
        <ion-item-divider class="edit-section-divider"><ion-label>{{ 'ALERT_SETTINGS.CONFIGURE_ALERT' | translate }}</ion-label></ion-item-divider>
        <ion-note class="configure-alert-note">{{ 'ALERT_SETTINGS.SELECT_ALERT_TYPES' | translate }}</ion-note>
        <!-- Desktop / large screens: checkbox list -->
        <div class="alert-type-checkboxes desktop-only" formArrayName="selectedAlertTypes">
          <ion-item *ngFor="let alert of alerts; let i = index" [formGroupName]="i" class="alert-type-row" lines="none">
            <ion-checkbox slot="start" formControlName="selected" (ionChange)="onAlertTypeToggled()"></ion-checkbox>
            <ion-label *ngIf="alert.type !== 'heated-to' && alert.type !== 'cooled-to'">{{ alert.name }}</ion-label>
            <ion-label *ngIf="alert.type === 'heated-to' && canAdminister" class="alert-type-with-temp">
              Kiln has heated to
              <ion-input type="number" [formControl]="alertSettingsForm.get('temp_variable')" class="temp-inline" placeholder="—"
                [class.invalid]="(alertSettingsForm.controls.temp_variable?.errors?.required) || (showTempVariable() && !alertSettingsForm.controls.temp_variable?.value)"></ion-input>
              degrees
            </ion-label>
            <ion-label *ngIf="alert.type === 'heated-to' && !canAdminister" class="alert-type-with-temp">
              Kiln has heated to {{ tempVariableDisplayValue() }} degrees
            </ion-label>
            <ion-label *ngIf="alert.type === 'cooled-to'" class="alert-type-with-temp">
              Kiln has cooled to {{ tempVariableDisplayValue() }} degrees
            </ion-label>
          </ion-item>
        </div>
        <!-- Small screens: multi-select popup for alert types -->
        <ion-item class="small-screen-only alert-types-multiselect" lines="none">
          <ion-label>{{ 'ALERT_SETTINGS.ALERT_TYPES' | translate }}</ion-label>
          <ion-select
            interface="action-sheet"
            multiple="true"
            [value]="getSelectedAlertTypesForSelect()"
            (ionChange)="onAlertTypesMultiChange($event)">
            <ion-select-option *ngFor="let alert of alerts" [value]="alert.type">
              {{ alert.name }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <!-- Small screens: temperature variable input when needed -->
        <ion-item class="small-screen-only alert-temp-input" lines="none" *ngIf="showTempVariable()">
          <ion-label>{{ 'ALERT_SETTINGS.TEMPERATURE_VARIABLE' | translate }}</ion-label>
          <ion-input
            type="number"
            [formControl]="alertSettingsForm.get('temp_variable')"
            placeholder="—">
          </ion-input>
        </ion-item>
        <ion-note *ngIf="showTempVariable() && (alertSettingsForm.controls.temp_variable?.errors?.required || (showTempVariable() && !alertSettingsForm.controls.temp_variable?.value))" class="temp-error-inline">
          {{ 'ALERT_SETTINGS.TEMP_VARIABLE_EMPTY' | translate }}
        </ion-note>
      </div>

      <!-- Right: Select users -->
      <div class="edit-column edit-column-users">
        <ion-item-divider class="edit-section-divider"><ion-label>{{ 'ALERT_SETTINGS.SELECT_USERS' | translate }}</ion-label></ion-item-divider>
        <ion-item lines="none" class="edit-note-item" *ngIf="gettingUsers || (selectedKiln && (!selectedKiln.users || selectedKiln.users.length === 0))">
          <ion-note *ngIf="gettingUsers"><ion-spinner name="bubbles"></ion-spinner></ion-note>
          <ion-note *ngIf="!gettingUsers && selectedKiln && (!selectedKiln.users || selectedKiln.users.length === 0)" class="error-users">
            {{ 'ALERT_SETTINGS.NO_USERS_SELECTED' | translate }}
          </ion-note>
        </ion-item>
        <ion-list *ngIf="!gettingUsers && selectedKiln && selectedKiln.users" formArrayName="enabled_users" class="enable-disable-users-for-alert">
          <ion-item-group *ngFor="let user of enabledUsers().controls; index as user_index" [formGroupName]="user_index" class="checkbox-list-item">
            <ion-item-divider class="user-divider">{{ user.value.username }}</ion-item-divider>
            <ion-item *ngIf="userHasEmail(user_index)" class="checkboxes ion-no-padding" lines="none">
              <ion-checkbox slot="start" *ngIf="!emailCanAlert(user_index)" [readonly]="true"></ion-checkbox>
              <ion-checkbox slot="start" *ngIf="emailCanAlert(user_index)" formControlName="email_checked"
                (ionChange)="checkboxChange($event, user_index)"></ion-checkbox>
              <ion-label slot="end">{{ user.value.email_label }}</ion-label>
            </ion-item>
            <ng-container *ngIf="userPhoneControls(user_index)?.length > 0" formArrayName="phones">
              <ion-item *ngFor="let phone of userPhoneControls(user_index); let phone_index = index" [formGroupName]="phone_index" class="checkboxes ion-no-padding" lines="none">
                <ion-checkbox slot="start" *ngIf="!(phone?.value?.can_be_checked)" [readonly]="true"></ion-checkbox>
                <ion-checkbox slot="start" *ngIf="phone?.value?.can_be_checked" formControlName="checked"
                  (ionChange)="checkboxChange($event, user_index)"></ion-checkbox>
                <ion-label slot="end">{{ phone.value.label }}</ion-label>
              </ion-item>
            </ng-container>
          </ion-item-group>
        </ion-list>
        <ng-container *ngIf="showPushNotifications && showPushDevicesSection()">
          <ion-item-divider class="edit-section-divider"><ion-label>{{ 'ALERT_SETTINGS.PUSH_NOTIFICATIONS' | translate }}</ion-label></ion-item-divider>
          <ion-list formArrayName="push_devices" class="enable-disable-users-for-alert">
            <ion-item *ngFor="let device of pushDevicesFormArray().controls; let device_index = index" [formGroupName]="device_index" class="checkboxes ion-no-padding" lines="none">
              <ion-checkbox slot="start" formControlName="enabled"></ion-checkbox>
              <ion-label slot="end">Push to {{ device.value.name || 'device' }}</ion-label>
            </ion-item>
          </ion-list>
        </ng-container>
        <ion-item lines="none" class="verification">
          <ion-note><sup>*</sup>{{ 'ALERT_SETTINGS.VERIFICATION_NOTE' | translate }}</ion-note>
        </ion-item>
      </div>
    </div>
  </form>
</ion-list>

<ion-item class="buttons">
  <ion-button slot="end" (click)="onDismiss ? onDismiss() : goBack()" class="close">{{ 'ALERT_SETTINGS.CLOSE' | translate }}</ion-button>
  <ion-button *ngIf="!viewMode" slot="end" (click)="cancelEditing()" fill="outline" color="dark" class="back-to-view-footer">{{ 'ALERT_SETTINGS.BACK_TO_VIEW' | translate }}</ion-button>
  <ion-button *ngIf="!viewMode && !savingSettings" slot="end" [class.disabled]="!editFormValid()" class="primary" (click)="saveAlertSettings(alertSettingsForm.value)">
    {{ 'ALERT_SETTINGS.SAVE' | translate }}
  </ion-button>
  <ion-button *ngIf="!viewMode && savingSettings" slot="end" disabled>
    <ion-spinner name="bubbles"></ion-spinner>
    <span>{{ 'ALERT_SETTINGS.SAVING_SETTINGS' | translate }}</span>
  </ion-button>
</ion-item>
